// extracted by mini-css-extract-plugin
module.exports = {"root":"radio-box_root__dxajC","row":"radio-box_row__22-aj","selectContainer":"radio-box_selectContainer__25hS-","icon":"radio-box_icon__34n4n","input":"radio-box_input__1TQ-S"};